import ManageAccountsMUIIcon from '@mui/icons-material/ManageAccounts';

type Props = {
  fill?: string;
};

export const ManageAccountsIcon = ({ fill }: Props) => (
  <ManageAccountsMUIIcon sx={{ color: fill }} />
);
